import React from 'react'

import Icon from '@/components/common/Icon'

const IconVisa: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, height, width }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5328_57538)">
      <path
        d="M82.9364 77.6484L64.3689 121.948H52.255L43.1179 86.595C42.5631 84.4174 42.0808 83.6197 40.3937 82.7023C37.6393 81.208 33.0906 79.806 29.0886 78.9359L29.3604 77.6484H48.8601C51.3457 77.6484 53.5801 79.303 54.1445 82.1653L58.9701 107.8L70.8964 77.6477H82.9364V77.6484ZM130.401 107.485C130.45 95.7927 114.233 95.1486 114.345 89.9256C114.379 88.336 115.893 86.646 119.206 86.2146C120.848 85.9996 125.372 85.8357 130.503 88.1971L132.516 78.8029C129.759 77.8021 126.211 76.8389 121.797 76.8389C110.47 76.8389 102.498 82.8604 102.431 91.4827C102.358 97.8602 108.121 101.419 112.463 103.538C116.929 105.708 118.428 107.103 118.411 109.044C118.379 112.016 114.848 113.328 111.549 113.379C105.789 113.468 102.446 111.821 99.7821 110.582L97.705 120.287C100.383 121.516 105.325 122.587 110.449 122.641C122.488 122.641 130.364 116.694 130.401 107.485ZM160.312 121.948H170.911L161.659 77.6484H151.876C149.677 77.6484 147.821 78.9293 147 80.8985L129.803 121.948H141.837L144.225 115.332H158.928L160.312 121.948ZM147.525 106.252L153.557 89.619L157.028 106.252H147.525ZM99.3101 77.6484L89.834 121.948H78.3745L87.8544 77.6484H99.3101V77.6484Z"
        fill="#1434CB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5328_57538">
        <rect width="200" height="200" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default Icon(IconVisa)
